import {
	CREATE_ADMIN_ROLES_START,
	CREATE_ADMIN_ROLES_SUCCESS,
	CREATE_ADMIN_ROLES_ERROR,
	DELETE_ADMIN_ROLES_START,
	DELETE_ADMIN_ROLES_SUCCESS,
	DELETE_ADMIN_ROLES_ERROR,
	ADMIN_PRIVILEGES_START,
	ADMIN_PRIVILEGES_SUCCESS,
	ADMIN_PRIVILEGES_ERROR
} from '../../../constants';
import {
	getAllAdminRolesQuery,
	createAdminRoleQuery,
	deleteAdminQuery,
	getPrivilegesQuery
} from '../../../lib/graphql';
import { closeAdminRolesModal } from '../modalActions';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { setLoaderComplete, setLoaderStart } from '../../loader/loader';

const createAdminRole = (id, name, description, privileges, currentPage) => {
	return async (dispatch, getState, { client }) => {

		try {
			await dispatch({
				type: CREATE_ADMIN_ROLES_START,
				payload: {
					createAdminRoleLoading: true
				}
			});
			dispatch(setLoaderStart('adminRoleLoading'));
			const { data } = await client.mutate({
				mutation: createAdminRoleQuery,
				variables: {
					id,
					name,
					description,
					privileges
				},
				refetchQueries: [{ query: getAllAdminRolesQuery, variables: { currentPage } }]
			});

			if (data && data.createAdminRole && data.createAdminRole.status === 200) {
				await dispatch({
					type: CREATE_ADMIN_ROLES_SUCCESS,
					payload: {
						createAdminRoleLoading: false
					}
				});
				dispatch(closeAdminRolesModal());
				dispatch(setLoaderComplete('adminRoleLoading'))
				showToaster({ messageId: 'adminRoleSuccess', requestContent: id, toasterType: 'success' });
			} else {
				await dispatch({
					type: CREATE_ADMIN_ROLES_ERROR,
					payload: {
						createAdminRoleLoading: false,
						error: data && data.createAdminRole && data.createAdminRole.errorMessage
					}
				});
				dispatch(setLoaderComplete('adminRoleLoading'))
				showToaster({ messageId: 'errorMessage', requestContent: data?.createAdminRole?.errorMessage, toasterType: 'error' });
			}
		} catch (error) {
			await dispatch({
				type: CREATE_ADMIN_ROLES_ERROR,
				payload: {
					createAdminRoleLoading: false,
					error
				}
			});
			showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
		}
	}
}

const deleteAdminRole = (id) => {
	return async (dispatch, getState, { client }) => {

		try {
			await dispatch({
				type: DELETE_ADMIN_ROLES_START,
				payload: {
					deleteAdminRoleLoading: true
				}
			});

			const { data } = await client.mutate({
				mutation: deleteAdminQuery,
				variables: {
					id
				},
				refetchQueries: [{ query: getAllAdminRolesQuery }]
			});

			if (data && data.deleteAdminRole && data.deleteAdminRole.status === 200) {
				await dispatch({
					type: DELETE_ADMIN_ROLES_SUCCESS,
					payload: {
						deleteAdminRoleLoading: false
					}
				});
				dispatch(closeAdminRolesModal());
				showToaster({ messageId: 'adminDeleteSuccess', toasterType: 'success' });
				return {
					status: data.deleteAdminRole.status
				}
			} else {
				showToaster({ messageId: 'errorMessage', requestContent: data?.deleteAdminRole?.errorMessage, toasterType: 'error' });
				await dispatch({
					type: DELETE_ADMIN_ROLES_ERROR,
					payload: {
						deleteAdminRoleLoading: false,
						error: data && data.deleteAdminRole && data.deleteAdminRole.errorMessage
					}
				});
				return {
					status: data.deleteAdminRole.status
				}
			}
		} catch (error) {
			showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
			await dispatch({
				type: DELETE_ADMIN_ROLES_ERROR,
				payload: {
					deleteAdminRoleLoading: false,
					error
				}
			});
		}
	}
}

const getPrivileges = () => {
	return async (dispatch, getState, { client }) => {

		try {
			await dispatch({
				type: ADMIN_PRIVILEGES_START
			});

			const { data } = await client.query({
				query: getPrivilegesQuery
			});			

			if (data && data.getPrivileges && data.getPrivileges.status === 200) {
				await dispatch({
					type: ADMIN_PRIVILEGES_SUCCESS,
					payload: {
						privileges: data.getPrivileges.results
					}
				});
			} else {
				await dispatch({
					type: ADMIN_PRIVILEGES_ERROR,
				});
			}
		} catch (error) {
			await dispatch({
				type: ADMIN_PRIVILEGES_ERROR,
			});
		}
	}
}

export { createAdminRole, deleteAdminRole, getPrivileges }